import ShareableLink from './ShareableLink.router';

export default ShareableLink;

export { default as shareableLinkRoutes } from './routes';
